import Cookies from 'js-cookie';
import Link from 'next/link';

import { ROUTES } from '@shared/constants/routes';
import { useAppDispatch } from '@shared/hooks/redux';
import { Button } from '@shared/ui/Button';
import { CloseIcon } from '@shared/ui/CloseIcon';
import { HStack } from '@shared/ui/Stack';
import { closeAboutCookieModal, closeAcceptCookieModal } from '@widgets/CookieModals/model/slice/cookieModalSlice';

import { ModalWrap } from '../ModalWrap/ModalWrap';
import cls from './AboutCookieModal.module.scss';

export const AboutCookieModal = () => {
  const dispatch = useAppDispatch();

  const handleCloseAboutCookie = () => {
    dispatch(closeAboutCookieModal());
  };

  const onClickOkButton = () => {
    Cookies.set('cookieAgreement', '1');
    dispatch(closeAboutCookieModal());
    dispatch(closeAcceptCookieModal());
  };

  return (
    <ModalWrap fixed={false}>
      <div
        data-testid={'about-cookie-modal'}
        className={cls.wrap}
      >
        <CloseIcon
          className={cls.close}
          testId={'about-cookie-modal-close-button'}
          onClick={handleCloseAboutCookie}
        />
        <h4 className={cls.title}>Что такое Cookie?</h4>
        <div className={cls.text}>
          Cookie включают в себя: сведения о местоположении; тип, язык и версию операционной системы и браузера;
          сведения об используемом устройстве. Данные обрабатываются для предоставления наших услуг и улучшения качества
          работы нашего веб-сайта и сервисов.
        </div>
        <br />
        <div className={cls.text}>Продолжая использовать наш сайт, вы соглашаетесь на обработку файлов cookie.</div>
        <HStack className={cls.buttons}>
          <Button
            testId={'about-cookie-modal-ok-button'}
            aria-label={'ОК'}
            onClick={onClickOkButton}
            size={'s'}
          >
            ОК
          </Button>
          <Link
            data-testid={'about-cookie-modal-policy-button'}
            aria-label={'Политика обработки файлов cookie'}
            className={cls.link}
            target={'_blank'}
            href={ROUTES.COOKIES_POLICY}
          >
            Политика обработки файлов cookie
          </Link>
        </HStack>
      </div>
    </ModalWrap>
  );
};
